export default "__VITE_ASSET__BdK4ebcL__"